import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRendererFormState } from "../../../../store/slices/commonSlice";
import { setProfileFieldsJSON } from "../../../../store/slices/profile/profileSlice";
import { getAllDropdownListItems } from "../../../../service/profile/profileService";
import Select from "react-select";
import FormGroupWrapper from "./FormGroupWrapper";
import { labelUtils } from "../Util";
import store from "../../../../store";

const CustomSelect = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState = {},
  displayLabelKey,
  databaseKey,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const profileFieldsJSON = useSelector(
    (state) => state.profile.ProfileFieldsJSON
  );
  const dataCustomValue = fieldEle?.["data-customvalue"];
  const datasourcelist = fieldEle?.["data-datasourcelist"];
  const parentAttributeKey = fieldEle?.["parent-attributekey"];
  const key = databaseKey || displayLabelKey;
  const displayYes = fieldEle?.["display-yes"];
  const required = fieldEle?.["display-required"] === 1;
  const parentSelectedValue = formState[parentAttributeKey];
  const customerData = useSelector((state) => state.common.customerData);

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        if (datasourcelist) {
          const response = await getAllDropdownListItems(
            datasourcelist,
            profileFieldsJSON,
            customerData.parenttype,
            customerData.parentid,
            "STA",
            parentSelectedValue
          );
          if (response) {
            const data = response;
            if (Array.isArray(data)) {
              const updatedOptions = data.map((item) => ({
                value: item.value || item.key,
                label: item.label || item.value || item.key,
              }));
              setOptions(updatedOptions);
              const updatedProfileFieldsJSON = {
                ...profileFieldsJSON,
                [datasourcelist]: {
                  ...profileFieldsJSON[datasourcelist],
                  "data-customvalue": updatedOptions,
                },
              };
              dispatch(setProfileFieldsJSON(updatedProfileFieldsJSON));
            } else {
              console.warn("Unexpected data format received:", data);
            }
          } else {
            console.error(
              "API Response is undefined or missing data property:",
              response
            );
          }
        } else {
          let optArray = [];
          if (typeof dataCustomValue === "string") {
            optArray = dataCustomValue.split("#");
          } else if (Array.isArray(dataCustomValue)) {
            optArray = dataCustomValue;
          }
          const updatedOptions = optArray.map((opt) => ({
            value: opt.value || opt.key || opt,
            label: opt.label || opt.value || opt.key || opt,
          }));
          setOptions(updatedOptions);
        }
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [datasourcelist, parentSelectedValue, dispatch]);

  useEffect(() => {
    if (required) {
      if (formState[key] === undefined || formState[key] === "") {
        setError("This field is required");
      } else {
        setError("");
      }
    } else {
      setError("");
    }
  }, [formState, key, required, options]);

  const parentSelected = displayYes ? formState[displayYes] : "";
  const shouldDisplay = ["yes", "true", "1"].includes(
    String(parentSelected || "").toLowerCase()
  );

  useEffect(() => {
    if (displayYes && shouldDisplay === false) {
      store.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
  }, [displayYes, shouldDisplay, databaseKey]);

  const displayDependent = fieldEle?.["display-dependent"];
  const displayIndex = fieldEle?.["display-index"];
  const dependentValue = displayDependent ? formState[displayDependent] : "";
  const shouldDisplayDependent =
    !displayDependent ||
    (dependentValue && parseInt(dependentValue) >= parseInt(displayIndex));

  useEffect(() => {
    if (displayDependent && !shouldDisplayDependent) {
      store.dispatch(
        setRendererFormState({ key: databaseKey || displayLabelKey, value: "" })
      );
    }
  }, [
    displayDependent,
    shouldDisplayDependent,
    databaseKey,
    displayLabelKey,
  ]);

  useEffect(() => {
    if (
      !formState[key] &&
      fieldEle["parent-key"] &&
      formState[fieldEle["parent-key"]]
    ) {
      dispatch(
        setRendererFormState({
          key,
          value: formState[fieldEle["parent-key"]],
        })
      );
    }
  }, []);

  if (displayYes && !shouldDisplay) {
    return null;
  }

  if (displayDependent && !shouldDisplayDependent) {
    return null;
  }

  const handleChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    dispatch(setRendererFormState({ key, value }));
    setError("");
  };

  const handleBlur = () => {
    const fieldValue = formState[key];
    if (required && (fieldValue === undefined || fieldValue === "")) {
      setError("This field is required");
    } else {
      setError("");
    }
  };

  const shouldShowDesc =
    !fieldEle?.["display-desc-value"] ||
    String(formState[key])?.toLowerCase() ===
      String(fieldEle?.["display-desc-value"])?.toLowerCase();

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div style={{ display: "none" }}>
          <input
            type="text"
            required={required}
            value={formState[key] || ""}
            onChange={(e) => handleChange({ value: e.target.value })}
          />
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : (
          <Select
            id={newElfromJSON}
            placeholder={
              fieldEle?.["display-placeholder"] || "Select an option"
            }
            value={
              options.find((option) => option?.value === formState[key]) || null
            }
            onChange={handleChange}
            onBlur={handleBlur}
            isDisabled={fieldEle?.["display-disabled"] === 1}
            isClearable
            className="mandatory"
            options={options}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 1050 }),
              dropdownIndicator: (base, state) =>
                state.isDisabled ? { ...base, display: "none" } : base,
              indicatorSeparator: (base, state) =>
                state.isDisabled ? { ...base, display: "none" } : base,
            }}
          />
        )}

        {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}

        {fieldEle?.["display-description"] && shouldShowDesc && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default CustomSelect;
